import React, { useEffect, useState } from 'react';
import {useSearchParams} from 'react-router-dom';
import { useStore } from '@/hooks/storeHooks';
import api from './api';
import st from './index.scss';
import toast from 'react-hot-toast';
import cn from 'classnames';

/**
 * @description: 题目报错弹窗
 *
 * reportErrorRef//弹窗ref
 * currentSubject//当前题目参数
 * questionId//当前题目id,学习效果测试与题库传参不同
 * kindId//当前题目练习类型
 */

export default function ReportError({ reportErrorRef, maxLength = 150, currentSubject, questionId,kindId }) {
  const { user } = useStore();
  const [params] = useSearchParams();
  const { isZhumavip } = useStore();
  const [errorTypeArr, setErrorTypeArr] = useState([]);
  const [errorType, setErrorType] = useState('');
  const [reportContent, setReportContent] = useState('');
  const [activeIndex, setActiveIndex] = useState(-1);
  const [InputLength, setInputLength] = useState(0);
  
  const paramsKindId = params.get('kindId');
  // const EXERCISE_TYPE = {
  //   // 1:'章节练习、分科测试',
  //   1:'章节练习',
  //   2:'历年真题',
  //   4:'背诵卡片',
  //   6:'精选案例',
  //   7:'智能组卷',
  //   8:'一题一练',
  //   9:'分科真题',
  //   10:'学习效果测试'
  // };

  useEffect(() => {
    getErrorType();
  }, []);

  async function getErrorType() {
    const { status, data } = await user.crmZhonghePost(api.get_error_type, {
      dictType: 'reportError',
      pageSize: 100,
      pageNum: 1,
    });
    if (status === 200) {
      setErrorTypeArr(data?.data?.records);
    }
  }

  async function sumbitReport() {
    if (!errorType) {
      toast.error('请选择报错类型');
      return;
    }
    if (!reportContent) {
      toast.error('请填写报错说明');
      return;
    }
    const res = await user.post(api.add_report_error, {
      userId: user.id,
      businessTypeId: currentSubject.businessTypeId,
      questionId: parseInt(questionId),
      reportType: errorType,
      reportContent,
      kindId:parseInt(paramsKindId)|| kindId,
      // kindName: paramsKindId? EXERCISE_TYPE[paramsKindId]:EXERCISE_TYPE[kindId],
      reportSource: isZhumavip() ? 'zhumaWeb' : 'schoolWeb',
    });
    if (res.status === 200) {
      toast.success('报错成功，感谢您的反馈');
      setErrorType('');
      setReportContent('');
      reportErrorRef.current.hide();
    }else{
      toast.error(res.error);
    }
  }
  return (
    <div className={st['mask']}>
      <div className={st['dialog']}>
        <div className={st['dialog_box']}>
          {/* 头部 */}
          <div className={st['dialog_hander']}>
            <div className={st['dialog_title']}>可选择错误类别</div>
            <div>
              <img
                className={st['close_img']}
                src="https://osscdn.zhongheschool.com/mallP2_2022_6_16/pc/createOrder/close.png"
                onClick={() => {
                  setErrorType('');
                  setReportContent('');
                  reportErrorRef.current.hide();
                }}
              />
            </div>
          </div>
          {/* 内容 */}
          <div className={st['dialog_content']}>
            <div className={st['dialog_content_btnbox']}>
              {errorTypeArr.map((item, index) => {
                return (
                  <div
                    className={cn({
                      [st['dialog_content_btn']]: activeIndex !== index,
                      [st['dialog_content_btn_active']]: activeIndex === index,
                    })}
                    key={item.id}
                    onClick={() => {
                      setActiveIndex(index);
                      setErrorType(item.id);
                    }}
                  >
                    {item.dictValue}
                  </div>
                );
              })}
            </div>
            <div className={st['dialog_input']}>
              <textarea
                placeholder="请填写报错内容"
                maxLength={maxLength}
                onInput={(e) => {
                  setInputLength(e.target.value.length);
                  if (e.target.value.length > maxLength) return;
                  setReportContent(e.target.value);
                }}
              ></textarea>
              <div className={st['words']}>
                <span>{InputLength}</span>/{maxLength}
              </div>
            </div>
          </div>
          {/* 底部 */}
          <div className={st['dialog_footer']}>
            <div
              className={st['dialog_footer_cancel']}
              onClick={() => {
                setErrorType('');
                setReportContent('');
                reportErrorRef.current.hide();
              }}
            >
              取消
            </div>
            <div className={st['dialog_footer_confirm']} onClick={sumbitReport}>
              提交
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
